<template>
  <div id="content" class="startup_page">
      <div class="content_div stats">
        <div class="row " >
          <h2 class="customH2 text-center">Your innovator pool
          <span v-if="sfname"><br/>for {{sfname}}</span></h2>
          <div class="col-12 mt50">
            <!-- <vue-collapsible-panel-group base-color="#3783C5" style="margin-bottom:20px;">
                <vue-collapsible-panel>
                    <template #title>
                            <h2 class="customH2">Basics Filters</h2>
                    </template>
                    <template #content>

                            <div class="filtre_list">
                              <div >
                                <div class="zone_input">
                                  <div class="zone_input_header">
                                    <span class="zone_input_name">Product category</span>
                                  </div>
                                  <v-autocomplete v-model="basic.product_category" :items="dict.product_category" item-title="name"  chips closable-chips multiple ></v-autocomplete>

                                  </div>

                              </div>
                              <div >
                                <div class="zone_input">
                                  <div class="zone_input_header">
                                    <span class="zone_input_name">Assets</span>
                                  </div>
                                  <v-autocomplete v-model="basic.assets" :items="dict.product_category" item-title="name" item-value="value" chips closable-chips multiple ></v-autocomplete>

                                  </div>

                              </div>


                        </div>
                        <button type="button" @click="apply_filter()" class="next_step_btn_small" :disabled="selected_filters.length == 0" name="button">Apply filters</button>


                    </template>
                </vue-collapsible-panel>
            </vue-collapsible-panel-group> -->
            <vue-collapsible-panel-group base-color="#3783C5">
                <vue-collapsible-panel>
                    <template #title>
                            <h2 class="customH2">Filters</h2>
                    </template>
                    <template #content>

                            <div class="filtre_list">
                              <div v-for="(filtre,f) in filtres" :key="f">
                                  <label class="checkbox">
                                      <input class="checkbox__input" type="checkbox" v-model="selected_filters" :value="filtre._id.$oid"/>
                                      <svg class="checkbox__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                                        <rect width="21" height="21" x=".5" y=".5" fill="#FFF" stroke="#3783C5" rx="3" />
                                        <path class="tick" stroke="#3783C5" fill="none" stroke-linecap="round" stroke-width="4" d="M4 10l5 5 9-9" />
                                      </svg>
                                      <span class="checkbox__label">{{filtre.filter_name}}</span>
                                    </label>

                              </div>


                        </div>
                        <button type="button" @click="apply_filter()" class="next_step_btn_small" :disabled="selected_filters.length == 0" name="button">Apply filters</button>


                    </template>
                </vue-collapsible-panel>
            </vue-collapsible-panel-group>
          </div>


          <div class="col-12 startup_selection_section">

            <div  v-if="hasData == true">
              <div class="chartCo">
                <CanvasJSChart :options="options" :style="styleOptions"   @chart-ref="chartInstance"/>
                <div class="hidder">

                </div>
              </div>

            </div>
            <div class="" v-else>
                <div class="alert alert-warning">
                  No innovators available for your criterias
                </div>
            </div>
            <div class="text-center mt20" v-if="hasData == true">
                <button type="button" @click="exportToPNG()" name="button" class="next_step_btn">Export to png file</button>
            </div>

          </div>
      </div>
            </div>
  </div>
</template>
<script>
import api from '../tools/api';
// import { debounce } from 'lodash';
//
import {
  VueCollapsiblePanelGroup,
  VueCollapsiblePanel,
} from '@dafcoe/vue-collapsible-panel'
import '@dafcoe/vue-collapsible-panel/dist/vue-collapsible-panel.css'
  import { toast } from 'vue-sonner'
export default {
  components: {
    VueCollapsiblePanelGroup,
    VueCollapsiblePanel,
  },
  name: 'StartupsStatsListSpace',
  data() {
    return {
      pageInfo: {
        mainTitle : " ",
        subTitle : " ",
      },
      sfname:"",
      colors: ["#3783C5","#B38D2F","#8984CC",'#B38B2F',"#0D528D"],
      startups : null,
      filtres: [],
      selected_filters: [],
      hasData : false,
      chart: null,
      styleOptions: {
  width: "100%",
  height: '800px'
},
basic:{
  product_category: [],
  assets: null,
},
dict:{
  product_category : [],
},
options: {
  responsive: true,
  animationEnabled: true,
  theme: "light2",
  title: {
    text: "",
    fontSize:16,
  },
  axisY: {
    title: "Percent match score",
    includeZero: true,
    maximum: 100,
    labelFontSize: 14,
    titleFontSize: 14,
  },
  axisX: {
     labelFontSize: 14,
     labelAutoFit:true,
      interval: 1,

 },
  legend: {
    cursor:"pointer",
    itemclick : this.toggleDataSeries,
    fontSize: 14,
  },
  toolTip: {
    shared: true,
    content: this.toolTipFormatter
  },
  data: [{
    type: "bar",
    showInLegend: true,
    name: "No data",
    color: "#000000",
    dataPoints: [{y:0,label:'Empty'}]
  }]
},
    }
  },
  methods:{
    exportToPNG() {
     // Check if the chart instance is available
     console.log(this.chart);
     if (this.chart) {
       // Get the canvas element from the chart
       const chartCanvas = this.chart.container.getElementsByTagName('canvas')[0];

       // Convert the canvas to a data URL
       const chartDataURL = chartCanvas.toDataURL('image/png');

       // Create a link element
       const link = document.createElement('a');
       link.href = chartDataURL;
       link.download ='startup_criteria_comparison.png';

       // Trigger a click event to start the download
       link.click();
       toast.success('Your chart has been downloaded !');
     } else {
       // Notify the user if the chart instance is not available
       toast.error('Chart instance not available.');
     }
   },
    apply_filter(){
      console.log(this.basic);
      api.post(process.env.VUE_APP_API_URL+"/test_filter_multiple_for_graph_view",
          {
              fids: this.selected_filters,
              basic : this.basic,
              search_field: this.$route.params.search_field
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log("THEN");
          console.log(r.data);
        this.startups = r.data;
        this.options.data = [];
        var data_array = [];
        const myArray = Object.keys(r.data).map(key => r.data[key]);
        myArray.forEach((item,i) => {
            var currentOption = {
              type: "bar",
              showInLegend: true,
              name: item.name,
              color: this.colors[i],
              dataPoints: []
            };
            // item.startups.sort((a, b) => a.main_score - b.main_score);

            item.startups.forEach((startup) => {
               currentOption.dataPoints.push({y:parseInt(startup.percent_score), sid:startup._id.$oid, label:startup.name, avg: startup.main_score});
            });


            data_array.push(currentOption);
        });
        for (let i = 0; i < data_array.length; i++) {
          const currentOption = data_array[i];

          // Loop through the remaining currentOption objects in the array
          for (let j = i + 1; j < data_array.length; j++) {
            const nextOption = data_array[j];

            // Add missing dataPoints to other currentOption objects
            this.addMissingDataPoints(nextOption, currentOption);
            this.addMissingDataPoints(currentOption, nextOption);
          }
        }
        data_array.forEach((item) => {

          item.dataPoints.sort((a, b) => {
             if (b.avg !== a.avg) {
               // Sort by value in descending order
               return a.avg - b.avg;
             } else {
               // If values are equal, sort by name in ascending order
               return a.sid.localeCompare(b.sid);
             }
           });

        });

        this.options.data = data_array;
        //  this.hasData = true;
        // this.$nextTick(() => {
        //   this.chart.render();
        // });

        this.options.data.forEach((dataitem) => {
            if(dataitem.dataPoints.length > 0) this.hasData =true;
        });
        if(this.hasData){
          this.$nextTick(() => {
            this.chart.render();
          });
        }



      });
    },
    chartInstance(chart) {
      this.chart = chart;
    },

    toggleDataSeries(e) {
      if (typeof (e.dataSeries.visible) === "undefined" || e.dataSeries.visible) {
        e.dataSeries.visible = false;
      }
      else {
        e.dataSeries.visible = true;
      }
      this.chart.render();
    },

    toolTipFormatter(e) {
	var str = "";
	var str2 ;
	for (var i = 0; i < e.entries.length; i++){
		var str1 = "<span style= \"color:"+e.entries[i].dataSeries.color + "\">" + e.entries[i].dataSeries.name + "</span>: <strong>"+  e.entries[i].dataPoint.y + "% match</strong> <br/>" ;
		str = str.concat(str1);
	}
	str2 = "<strong>" + e.entries[0].dataPoint.label + "</strong> <br/>";
	return (str2.concat(str));
},
addMissingDataPoints(targetOption, sourceOption) {
  // Iterate through dataPoints in the sourceOption
  sourceOption.dataPoints.forEach(sourceDataPoint => {
    // Check if the targetOption already has a dataPoint with the same x value
    const existingDataPoint = targetOption.dataPoints.find(
      targetDataPoint => targetDataPoint.sid === sourceDataPoint.sid
    );

    // If not, add the dataPoint to the targetOption
    if (!existingDataPoint) {
      targetOption.dataPoints.push({ sid: sourceDataPoint.sid, label: sourceDataPoint.label, y: 0, avg: sourceDataPoint.avg });
    }
  });
}
  },
  mounted(){
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo);
     api.get(process.env.VUE_APP_API_URL+"/search_field/isAssess/"+this.$route.params.search_field).then( (r) => {
       this.sfname = r.data.name;
     }).catch( (e) => {console.log(e)});

     api.get(process.env.VUE_APP_API_URL+"/restrict/dict/dict_product_category").then( (r) => {
           console.log("INNOV AREA");
       console.log(r);
       r.data.forEach((item) => {
         delete item["_id"];
         delete item["customer"];
           delete item["ordre"];
       });
       this.dict.product_category = r.data
     }).catch( (e) => {
     if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
     else toast.error("Oops! Something went wrong")
     });


     api.get(process.env.VUE_APP_API_URL+"/restrict/my_filters").then( (r) =>{
       this.filtres = r.data;

       if(this.$route.params.filterstoapply){
         console.log(this.$route.params.filterstoapply);
         this.selected_filters = JSON.parse(this.$route.params.filterstoapply);
         api.post(process.env.VUE_APP_API_URL+"/test_filter_multiple_for_graph_view",
             {
                 fids: this.selected_filters,
                 basic: this.basic,
                 search_field: this.$route.params.search_field
             },
             {
               headers: {
                   'Content-Type': 'application/json',
             }
           }).then( (r) => {
           this.startups = r.data;
           this.options.data = [];
           var data_array = [];
           const myArray = Object.keys(r.data).map(key => r.data[key]);
           console.log(myArray);
           myArray.forEach((item,i) => {
               var currentOption = {
                 type: "bar",
                 showInLegend: true,
                 name: item.name,
                 color: this.colors[i],
                 dataPoints: []
               };
               // item.startups.sort((a, b) => a.main_score - b.main_score);

               item.startups.forEach((startup) => {
                  currentOption.dataPoints.push({y:parseInt(startup.percent_score), sid:startup._id.$oid, label:startup.name, avg: startup.main_score});
               });


               data_array.push(currentOption);
           });
           for (let i = 0; i < data_array.length; i++) {
             const currentOption = data_array[i];

             // Loop through the remaining currentOption objects in the array
             for (let j = i + 1; j < data_array.length; j++) {
               const nextOption = data_array[j];

               // Add missing dataPoints to other currentOption objects
               this.addMissingDataPoints(nextOption, currentOption);
               this.addMissingDataPoints(currentOption, nextOption);
             }
           }
           data_array.forEach((item) => {

             item.dataPoints.sort((a, b) => {
                if (b.avg !== a.avg) {
                  // Sort by value in descending order
                  return a.avg - b.avg;
                } else {
                  // If values are equal, sort by name in ascending order
                  return a.sid.localeCompare(b.sid);
                }
              });

           });

           this.options.data = data_array;

          this.options.data.forEach((dataitem) => {
              if(dataitem.dataPoints.length > 0) this.hasData =true;
          });
          this.styleOptions.height = Math.max((this.options.data[0].dataPoints.length * 30),400) + "px";
          if(this.hasData){
            this.$nextTick(() => {
              this.chart.render();
            });
          }



         });
       }
     });



  },


}
</script>
<style scoped>

.startup_page{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding: 50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}
.chart-container {
  position: relative;
}

.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  border: 1px solid #3783C5 !important;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}

.prev_step_btn,
.prev_step_btn:hover{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
    text-decoration: none;
}

.canvasjs-chart-credit{
  display:none;
}

.mt50{
  margin-top:50px;
}

.candidate{
  margin-top:20px;
  margin-bottom: 20px;
}
.candidate_card{
  border: 1px solid #DDDDDD;
border-radius: 10px;
z-index: 5;
height:100%;
display: flex;
flex-direction: column;
}
.candidate_card .candidate_image{
  width:100%;
  height:200px;
  object-fit: cover;
  z-index: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.candidate_card .candidate_info_content{
  padding:20px;
  border-bottom: 1px solid #DDDDDD;
}

.candidate_card .candidate_links{
  padding:20px;
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.candidate_card .candidate_info_content .candidate_name{
  font-size:18px;
  line-height:21px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
font-weight: 500;
}

.candidate_card .candidate_info_content .candidate_desc{
  font-size:16px;
  line-height:22px;
  margin-top:10px;
  display:block;
  margin-bottom:10px;
}
.candidate_card .candidate_links .details{
  font-size:12px;
  line-height: 15px;
  border-right: 1px solid #DDD;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
  flex: 0.5;

}
.candidate_card .candidate_links .details a{
    text-decoration: none;
}
.candidate_card .candidate_links .details img{
  margin-right:5px;
}
.candidate_card .candidate_links .selectIt{
  font-size:12px;
  line-height: 15px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  flex:1;
  align-items: flex-end;

}
.candidate_card .candidate_links .selectIt label{
display:flex;
align-items: center;
gap: 5px;
justify-content: end;
}
.candidate_card .candidate_links .selectIt input{
  width:24px;
  height:24px;
}
.candidate_card .candidate_links .details.noBorder{
  border-right: none;

}
@media screen and (max-width: 690px){
  .candidate_card .candidate_links{
    flex-direction: column;
    flex-wrap: wrap;
    gap: 20px
  }
  .candidate_pool{
      padding: 20px;
    }
    .candidate_card .candidate_links .details{
      border-right: none;
      border-bottom:1px solid #DDD;
      padding-bottom: 20px;
    }
}

.titre{
  margin-bottom: 20px;
  color: #3783C5;
  text-transform: uppercase;
}


.checkbox {
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom:20px;
}
.checkbox__input {
  position: absolute;
  width: 1.375em;
  height: 1.375em;
  opacity: 0;
  cursor: pointer;
}
.checkbox__input:checked + .checkbox__icon .tick {
  stroke-dashoffset: 0;
}
.checkbox__icon {
  width: 1.375em;
  height: 1.375em;
  flex-shrink: 0;
  overflow: visible;
}
.checkbox__icon .tick {
  stroke-dasharray: 20px;
  stroke-dashoffset: 20px;
  transition: stroke-dashoffset 0.2s ease-out;
}
.checkbox__label {
  margin-left: 0.5em;
}

.filtres{

  padding:0;
}
.filtres_head .customH2{
  display: block;
  width: 100%;
  background: #3783C5;
  color: #FFF;
  padding: 10px;
}
.filtre_list{
  padding:10px;
}

.next_step_btn_small, .next_step_btn_small:hover {
  background: #3783C5 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  border: 1px solid #3783C5 !important;
  border-radius: 50px;
  opacity: 1;
  padding: 5px 20px;
  color: #FFF;
  margin: auto;
  display:block;
  margin-top:20px;
  margin-bottom: 20px;
}
.startup_zone_legend{
  align-self: top;
}
.zone_startups{
    align-self: center;
}
.zone_title{
  font-size: 25px;
  color: #3783C5;
  font-weight: 700;
  text-align: center;
  display:block;
  width:100%;
  text-align:center;

}
.zone_number{
  font-size: 16px;
  color: #3783C5;
  font-weight: 700;
  text-align: center;
  display:block;
  width:100%;
  text-align:center;

}

.row.zone{
  padding-bottom: 50px;
  padding-top:50px;
  border-bottom: 2px dashed #CCC;
}

.startup_zone_legend.stickit .legend{
  position: sticky;
    top: 50%; /* Adjust the top value as needed */
}

.startup_zone_legend:not(.stickit){
  align-self: center;
}

.alert{
  margin:0;
}

  .startup_selection_section{
    margin-top:50px;
  }


.filtre_list{
  display: grid;
    grid-template-columns: auto auto auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-rows: 100%;
    gap:10px;
}

.chartCo{
  position:relative;
}
.chartCo .hidder{
  position:absolute;
  width:63px;
  height:14px;
  background:#FFF;
  bottom:0;
  right:0;
}
</style>
<style media="screen">
  .vcp__header{
    background-color:#3783C5 !important;
    color:#FFF !important;
    padding:20px !important;
  }
  .vcp__body {
 border-top: 1px solid #3783C5 !important;
}
.vcpg{
   border: 1px solid #3783C5 !important;
}
  .vcp__header .customH2{
    font-size:20px;
    line-height:20px;
    margin:0;
  }
</style>
